import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  // 23 hours, 59 mins, 51 secs = 86391 seconds
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(86391);
  return <div className="sticky top-0 z-50 bg-brand-burgundy text-white py-3 px-4 text-center shadow-md pt-[1px] pb-[1px] pl-[9px] pr-[9px]" data-id="element-327">
      <p className="text-sm md:text-base font-medium flex flex-wrap items-center justify-center gap-2" data-id="element-328">
        <span data-id="element-329">⚠️ PRECIO DE LANZAMIENTO CIERRA EN:</span>
        <span className="font-mono font-bold bg-black/20 px-2 py-1 rounded" data-id="element-330">
          {hours} hs : {minutes} min : {seconds} seg
        </span>
        
      </p>
    </div>;
}